import { Injectable } from "@angular/core";

import { FrontendPermission } from "../model/frontend-permission.model";
import { PermissionSpecification } from "../interface/type/permission-specification.type";
import { UIPermission } from "../interface/type/ui-permission.type";
import { UIPermissionWrapper } from "../model/ui-permission-wrapper.model";

    /**
     * @description
     *  Servicio principal del frontend de la aplicación.
     */

@Injectable({ providedIn: "root" })
export class FrontendService {

    constructor() {}

    public permissionFor(component: string): UIPermissionWrapper {
        const uiPermission: UIPermission = this.specification()[component];
        if (uiPermission === undefined) {
            throw new Error(
                `El componente especificado no posee permisos de UI definidos: '${component}'.`);
        }
        else {
            return new UIPermissionWrapper(uiPermission);
        }
    }

    public specification(): PermissionSpecification {
        return FrontendPermission;
    }
}
